<template>
  <div class="page-tone">
    <TopHeader class="landing-container-top" />
    <Banner @handler="handleTrail" />
    <AiToneEngine />
    <Customization @consult="showContact" />
    <ToneLibrary />
    <Operation @handle-trial="handleTrail" />
    <Faq />
    <StartRightNow :handler="handleTrail" />
    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import AppFooter from '~/design/widgets/bottom-footer/footer-cn.vue';
import Operation from '~/design/widgets/product-operation/cn-operation.vue';
import StartRightNow from '~/design/widgets/start-right-now/index.vue';
import TopHeader from '~/design/widgets/top-header/index.vue';
import AiToneEngine from './modules/ai-tone-engine/index.vue';
import Banner from './modules/banner/index.vue';
import Customization from './modules/customization/index.vue';
import Faq from './modules/faq/index.vue';
import ToneLibrary from './modules/tone-library/index.vue';
import { showDynamicContact } from './utils/contact';

const handleTrail = () => {
  const userInfo = useUserInfo();
  if (!userInfo.value) {
    navigateTo(
      `/login?redirect=${encodeURIComponent(encodeURIComponent(`${location.origin}/workspace`))}`,
    );
  } else {
    location.href = '/workspace';
  }
};

const showContact = () => {
  showDynamicContact(1609507, '企业级数字人定制', '1V1专属咨询服务');
};
</script>

<style lang="scss" src="./styles/pc.scss" scoped />
